export default "__VITE_ASSET__5fddada0__"